// DS8.4
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import React from 'react';
import classnames from 'classnames';
import numeral from 'numeral';
import { withTranslation } from 'react-i18next';
import onClickOutside from 'react-onclickoutside';
import { BiData } from '@wix/da-bi/pkg/events';
import { URLS, Url } from '@wix/da-url';
import MenuList from '../../../Dropdown/MenuList';
import UserAvatar from '../../../User/Avatar';
import UserAvatarPlaceholder from '../../../User/AvatarPlaceholder';
import UserLink from '../../../User/Link';
import MatureToggle from '../../../MatureToggle';
import CoreMenuItem from '../CoreMenuItem';
import LogoutItem from '../LogoutItem';
import BiSpan from '@wix/da-bi/pkg/Components/BiSpan';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import Flex from '@wix/da-ds/pkg/Flex';
import VerificationReminder from '../VerificationReminder';
import ThemeSwitchGreen from '@wix/da-ds/pkg/Icons/ThemeSwitchGreen';
import ThemeSwitchLight from '@wix/da-ds/pkg/Icons/ThemeSwitchLight';
import ThemeSwitchDark from '@wix/da-ds/pkg/Icons/ThemeSwitchDark';
import Button from '../../../Button';
import SaleBanner from '../../../SaleBanner';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';
import { ThemeOverride, ThemeOptions, ThemeSkin } from '@wix/da-react-context/pkg/ThemeContext';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import AISuppressionSettingItem from '../AISuppressionSettingItem';
import SiteHeaderStyles from '../../SiteHeaderDesktop/SiteHeaderDesktop.scss';
import s from './UserDropdownMenu.scss';
export class UserDropdownMenu extends React.Component {
    renderLoggedInMenu() {
        const { t, className, currentUser, pointsCount, fragmentsBalance, csrfToken, verificationEmail, hasCryptoWallet, ai_generated, showWeb3WalletModal } = this.props;
        const loggedInUser = currentUser;
        return /*#__PURE__*/ React.createElement(MenuList, {
            id: "site-header-user-menu",
            className: classnames(className, s['user-menu'], SiteHeaderStyles['icon-submenu']),
            renderOnSSR: true,
            items: [
                {
                    items: [
                        {
                            label: /*#__PURE__*/ React.createElement(Flex, {
                                alignItems: "baseline",
                                justifyContent: "space-between",
                                className: s['user-profile-line']
                            }, /*#__PURE__*/ React.createElement(UserLink, {
                                className: s['user-link'],
                                symbolClassName: s['user-link-symbol'],
                                user: loggedInUser,
                                withTooltip: false,
                                biData: {
                                    sectionname: 'menu'
                                }
                            }))
                        },
                        this.getBuyCore(),
                        this.getSubscriptions(),
                        this.getSaleBanner()
                    ]
                },
                !!verificationEmail && {
                    items: [
                        {
                            label: /*#__PURE__*/ React.createElement(VerificationReminder, {
                                email: verificationEmail
                            }),
                            className: s['verification-item']
                        }
                    ],
                    className: s['verification-group']
                },
                !verificationEmail && {
                    items: [
                        {
                            label: t('siteHeader.userMenu.myStash'),
                            link: Url.buildFromPath(URLS.STASH),
                            biData: BiData({
                                evid: 702,
                                link_url: Url.buildFromPath(URLS.STASH),
                                menu_item: 'stash',
                                menu_name: 'profile'
                            })
                        }
                    ]
                },
                !verificationEmail && {
                    items: [
                        {
                            label: /*#__PURE__*/ React.createElement("div", {
                                className: s['two-side-label']
                            }, /*#__PURE__*/ React.createElement("span", null, t('siteHeader.userMenu.pointsBalance')), pointsCount && /*#__PURE__*/ React.createElement("span", null, numeral(pointsCount).format('0,0'))),
                            link: Url.buildFromPath(URLS.POINTS),
                            biData: BiData({
                                evid: 702,
                                link_url: Url.buildFromPath(URLS.POINTS),
                                menu_item: 'points',
                                menu_name: 'profile'
                            })
                        },
                        {
                            label: /*#__PURE__*/ React.createElement("div", {
                                className: s['two-side-label']
                            }, /*#__PURE__*/ React.createElement("span", null, t('siteHeader.userMenu.fragmentsBalance')), /*#__PURE__*/ React.createElement("span", null, numeral(fragmentsBalance).format('0,0'))),
                            link: 'https://www.deviantartsupport.com/en/article/what-are-badges-and-fragments',
                            target: '_blank',
                            className: s['fragments-link'],
                            biData: BiData({
                                evid: 702,
                                link_url: 'https://www.deviantartsupport.com/en/article/what-are-badges-and-fragments',
                                menu_item: 'fragments',
                                menu_name: 'profile'
                            })
                        },
                        {
                            label: t('siteHeader.userMenu.myEarnings'),
                            link: Url.buildFromPath(URLS.EARNINGS),
                            biData: BiData({
                                evid: 702,
                                link_url: Url.buildFromPath(URLS.EARNINGS),
                                menu_item: 'earnings',
                                menu_name: 'profile'
                            })
                        },
                        {
                            label: t('siteHeader.userMenu.myOrderHistory'),
                            link: Url.buildFromPath(URLS.ORDERS),
                            biData: BiData({
                                evid: 702,
                                link_url: Url.buildFromPath(URLS.ORDERS),
                                menu_item: 'order_history',
                                menu_name: 'profile'
                            })
                        },
                        {
                            label: t('siteHeaderMobile.userMenu.customerDashboard'),
                            link: Url.buildFromPath(URLS.CUSTOMER_DASHBOARD),
                            biData: BiData({
                                evid: 702,
                                link_url: Url.buildFromPath(URLS.CUSTOMER_DASHBOARD),
                                menu_item: 'customer_dashboard',
                                menu_name: 'profile'
                            })
                        }
                    ]
                },
                {
                    items: [
                        !!verificationEmail && {
                            label: t('siteHeader.userMenu.myOrderHistory'),
                            link: Url.buildFromPath(URLS.ORDERS),
                            biData: BiData({
                                evid: 702,
                                link_url: Url.buildFromPath(URLS.ORDERS),
                                menu_item: 'order_history',
                                menu_name: 'profile'
                            })
                        },
                        this.getThemeSwitcherIfApplicable(),
                        hasCryptoWallet && {
                            label: 'My Web3 Wallets',
                            onClick: showWeb3WalletModal
                        },
                        {
                            label: t('siteHeader.userMenu.settings'),
                            link: Url.buildFromPath(URLS.SETTINGS),
                            biData: BiData({
                                evid: 702,
                                link_url: Url.buildFromPath(URLS.SETTINGS),
                                menu_item: 'settings',
                                menu_name: 'profile'
                            })
                        },
                        this.getContentFilterItem(),
                        ai_generated && {
                            label: /*#__PURE__*/ React.createElement(AISuppressionSettingItem, {
                                isLoggedIn: true
                            })
                        }
                    ],
                    className: verificationEmail && s['post-verification-group']
                },
                {
                    items: [
                        {
                            label: t('siteHeader.userMenu.helpAndFAQ'),
                            link: URLS.HELP,
                            target: '_blank',
                            biData: BiData({
                                evid: 702,
                                link_url: URLS.HELP,
                                menu_item: 'help_and_faq',
                                menu_name: 'profile'
                            })
                        },
                        {
                            label: /*#__PURE__*/ React.createElement(LogoutItem, {
                                formRef: this.logoutItemRef,
                                token: csrfToken,
                                label: /*#__PURE__*/ React.createElement(BiSpan, {
                                    biData: BiData({
                                        evid: 702,
                                        link_url: URLS.LOGOUT,
                                        menu_item: 'logout',
                                        menu_name: 'profile'
                                    })
                                }, t('siteHeader.userMenu.logOut'))
                            }),
                            onClick: this.handleLogout
                        }
                    ]
                }
            ]
        });
    }
    renderLoggedOutMenu() {
        const { t, className, ai_generated } = this.props;
        return /*#__PURE__*/ React.createElement(MenuList, {
            id: "site-header-user-menu",
            className: classnames(className, s['user-menu'], SiteHeaderStyles['icon-submenu']),
            renderOnSSR: true,
            items: [
                {
                    items: [
                        this.getBuyCore(),
                        this.getSaleBanner(),
                        this.getThemeSwitcherIfApplicable(),
                        // note: they kept the old toggle here even after 3 lvls of contentFilter
                        // were added because they thought it was better to send folks to sisu
                        this.getMatureToggleItem(),
                        ai_generated && {
                            label: /*#__PURE__*/ React.createElement(AISuppressionSettingItem, null)
                        }
                    ]
                },
                {
                    items: [
                        {
                            label: t('siteHeader.userMenu.helpAndFAQ'),
                            link: URLS.HELP,
                            biData: BiData({
                                evid: 702,
                                link_url: URLS.HELP,
                                menu_item: 'help_and_faq',
                                menu_name: 'profile'
                            })
                        },
                        {
                            label: t('siteHeader.userMenu.termsOfService'),
                            link: Url.buildFromPath(URLS.TOS),
                            biData: BiData({
                                evid: 702,
                                link_url: Url.buildFromPath(URLS.TOS),
                                menu_item: 'tos',
                                menu_name: 'profile'
                            })
                        },
                        {
                            label: t('siteHeader.userMenu.privacyPolicy'),
                            link: Url.buildFromPath(URLS.PRIVACY),
                            biData: BiData({
                                evid: 702,
                                link_url: Url.buildFromPath(URLS.PRIVACY),
                                menu_item: 'privacy_policy',
                                menu_name: 'profile'
                            })
                        }
                    ]
                }
            ]
        });
    }
    render() {
        const { t, currentUser, verificationEmail, isLoggedIn, isOpen, innerRef } = this.props;
        const { touchIsOpen } = this.state;
        return /*#__PURE__*/ React.createElement("div", {
            className: classnames(s['user-dropdown'], SiteHeaderStyles['icon-button-has-submenu'], (isOpen || touchIsOpen) && SiteHeaderStyles['active'], verificationEmail && SiteHeaderStyles['pulsing-animation']),
            ref: innerRef
        }, /*#__PURE__*/ React.createElement(Button, {
            view: "b3",
            className: s['user-menu-button'],
            "aria-haspopup": true,
            "aria-expanded": isOpen,
            "aria-controls": "site-header-user-menu",
            onClick: this.handleClickUserMenuOpen
        }, t('siteHeader.userMenu.open')), isLoggedIn && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(UserAvatar, {
            user: currentUser,
            size: 30,
            className: s['avatar'],
            withLink: true,
            onTouchEnd: (e)=>this.handleTouch(e),
            withTooltip: false,
            biData: {
                sectionname: 'header'
            }
        }), this.renderLoggedInMenu()), !isLoggedIn && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
            className: s['avatar']
        }, /*#__PURE__*/ React.createElement(UserAvatarPlaceholder, {
            width: 30,
            height: 30
        })), this.renderLoggedOutMenu()));
    }
    constructor(...args){
        super(...args);
        _define_property(this, "state", {
            touchIsOpen: false
        });
        _define_property(this, "logoutItemRef", /*#__PURE__*/ React.createRef());
        _define_property(this, "getBuyCore", ()=>{
            const { hasCoreMembership, coreLevel, usermenu_core_entry } = this.props;
            const linkUrl = hasCoreMembership && !usermenu_core_entry ? Url.account() : Url.coreMembershipLink();
            return {
                label: /*#__PURE__*/ React.createElement(CoreMenuItem, {
                    className: s['two-side-label'],
                    hasCoreMembership: hasCoreMembership,
                    coreLevel: coreLevel
                }),
                link: linkUrl,
                biData: BiData({
                    evid: 702,
                    link_url: linkUrl,
                    menu_item: hasCoreMembership ? 'my_core' : 'core_membership',
                    menu_name: 'profile'
                })
            };
        });
        _define_property(this, "getSubscriptions", ()=>{
            const { currentUser, hasSubscriptions, t } = this.props;
            const loggedInUser = currentUser;
            if (!loggedInUser || !hasSubscriptions) {
                return null;
            }
            const linkUrl = Url.userSubscriptionsLink({
                username: loggedInUser.username
            });
            return {
                label: /*#__PURE__*/ React.createElement("div", {
                    className: s['two-side-label']
                }, /*#__PURE__*/ React.createElement("span", null, t('siteHeader.userMenu.mySubscriptions')), /*#__PURE__*/ React.createElement("span", null, /*#__PURE__*/ React.createElement(ThemeOverride, {
                    theme: ThemeOptions.LIGHT
                }, /*#__PURE__*/ React.createElement(PromoBadge, {
                    badgeType: "tier",
                    size: 24
                })))),
                link: linkUrl,
                biData: BiData({
                    evid: 702,
                    link_url: linkUrl,
                    menu_item: 'my_subscriptions',
                    menu_name: 'profile'
                })
            };
        });
        _define_property(this, "getSaleBanner", ()=>{
            const { currentPromo } = this.props;
            return currentPromo && {
                className: s['non-clickable'],
                label: /*#__PURE__*/ React.createElement(SaleBanner, {
                    className: s['sale-banner'],
                    isNarrow: true,
                    endDate: currentPromo.endDate,
                    discountValuePercent: currentPromo.discountValuePercent,
                    referralType: ReferralType.PROMOTION_BANNER_USERMENU
                })
            };
        });
        _define_property(this, "getMatureToggleItem", ()=>{
            const { t, matureContent = false, toggleMature } = this.props;
            return {
                label: /*#__PURE__*/ React.createElement("div", {
                    className: s['two-side-label']
                }, /*#__PURE__*/ React.createElement("span", {
                    id: "mature-toggle-label",
                    onClick: ()=>toggleMature(matureContent)
                }, t('siteHeader.userMenu.matureContent')), /*#__PURE__*/ React.createElement(MatureToggle, {
                    size: "small",
                    value: matureContent,
                    onChange: toggleMature,
                    "aria-labelledby": "mature-toggle-label"
                })),
                biData: BiData({
                    evid: 702,
                    menu_item: 'toggle_mature',
                    menu_name: 'profile',
                    toggle_value: !matureContent ? 'mature_on' : 'mature_off'
                })
            };
        });
        _define_property(this, "getContentFilterItem", ()=>{
            const { t, contentFilter = 'standard', pushUserSettingsModal } = this.props;
            return {
                label: /*#__PURE__*/ React.createElement("div", {
                    className: s['two-side-label'],
                    onClick: pushUserSettingsModal
                }, /*#__PURE__*/ React.createElement("span", null, t('siteHeader.userMenu.contentFilter')), /*#__PURE__*/ React.createElement("span", null, t(`siteHeader.userMenu.contentFilter.${contentFilter}`))),
                biData: BiData({
                    evid: 702,
                    menu_item: 'content_filter',
                    menu_name: 'profile',
                    toggle_value: contentFilter
                })
            };
        });
        _define_property(this, "getThemeSwitcherIfApplicable", ()=>{
            const { t, disableThemeSwitcher, theme, themeSkin, setThemeSkin, setTheme } = this.props;
            if (disableThemeSwitcher) {
                return null;
            }
            return {
                className: s['non-clickable'],
                isInteractive: false,
                label: /*#__PURE__*/ React.createElement("div", {
                    className: s['two-side-label']
                }, /*#__PURE__*/ React.createElement("span", null, t('siteHeader.userMenu.mode')), /*#__PURE__*/ React.createElement("span", {
                    className: s['theme-toggles']
                }, /*#__PURE__*/ React.createElement(BiSpan, {
                    title: t('siteHeader.userMenu.themeDark'),
                    onClick: ()=>setTheme(ThemeOptions.DARK),
                    className: classnames(s['theme-toggle-item'], theme === ThemeOptions.DARK && !themeSkin && s['active']),
                    biData: BiData({
                        evid: 702,
                        menu_item: 'toggle_theme',
                        menu_name: 'profile',
                        toggle_value: 'dark'
                    })
                }, /*#__PURE__*/ React.createElement(ThemeSwitchDark, {
                    size: IconSize.LARGE
                })), /*#__PURE__*/ React.createElement(BiSpan, {
                    title: t('siteHeader.userMenu.themeLight'),
                    onClick: ()=>setTheme(ThemeOptions.LIGHT),
                    className: classnames(s['theme-toggle-item'], theme === ThemeOptions.LIGHT && !themeSkin && s['active']),
                    biData: BiData({
                        evid: 702,
                        menu_item: 'toggle_theme',
                        menu_name: 'profile',
                        toggle_value: 'light'
                    })
                }, /*#__PURE__*/ React.createElement(ThemeSwitchLight, {
                    size: IconSize.LARGE
                })), /*#__PURE__*/ React.createElement(BiSpan, {
                    title: t('siteHeader.userMenu.themeGreen'),
                    onClick: ()=>setThemeSkin(ThemeSkin.GREEN),
                    className: classnames(s['theme-toggle-item'], themeSkin === ThemeSkin.GREEN && s['active']),
                    biData: BiData({
                        evid: 702,
                        menu_item: 'toggle_theme',
                        menu_name: 'profile',
                        toggle_value: 'green'
                    })
                }, /*#__PURE__*/ React.createElement(ThemeSwitchGreen, {
                    size: IconSize.LARGE
                }))))
            };
        });
        _define_property(this, "handleLogout", ()=>{
            this.props.onUserLogoutButtonClicked();
            // Avoid a race condition and let sagas do their thing before submitting the form
            setTimeout(()=>{
                this.logoutItemRef && this.logoutItemRef.current && this.logoutItemRef.current.submit();
            }, 100);
        });
        _define_property(this, "handleTouch", (e)=>{
            e.preventDefault();
            this.setState({
                touchIsOpen: true
            });
        });
        _define_property(this, "handleClickOutside", ()=>{
            if (!this.state.touchIsOpen) {
                return;
            }
            this.setState({
                touchIsOpen: false
            });
        });
        _define_property(this, "handleClickUserMenuOpen", ()=>{
            this.setState({
                touchIsOpen: !this.state.touchIsOpen
            });
        });
    }
}
export default withTranslation()(onClickOutside(UserDropdownMenu));
